import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FeatureStatus } from 'src/app/data-models/common/feature-status.model';

@Component({
	selector: 'vtr-widget-quicksettings-note',
	templateUrl: './widget-quicksettings-note.component.html',
	styleUrls: ['./widget-quicksettings-note.component.scss'],
})
export class WidgetQuicksettingsNoteComponent implements OnInit {
	@Output() onClick = new EventEmitter<string>();
	@Input() microphoneStatus = new FeatureStatus(true, false);
	@Input() isMicrophoneVisible: boolean;

	constructor() {}

	ngOnInit(): void {}

	public onPermissionNoteGoToWindowsClick() {
		let path: string;
		const hasMicrophonePermissionNote = this.isMicrophonePermissionDenied();

		if (hasMicrophonePermissionNote) {
			path = 'ms-settings:privacy-microphone';
		}

		if (path) {
			this.onClick.emit(path);
		}
	}

	public isAccessPermissionNoteVisible(): boolean {
		const isMicrophonePermissionDenied = this.isMicrophonePermissionDenied();
		const hasMicrophoneNote = isMicrophonePermissionDenied && this.isMicrophoneVisible;
		return hasMicrophoneNote;
	}

	public getPermissionNoteMessage(): string {
		const isMicrophonePermissionDenied = this.isMicrophonePermissionDenied();

		const hasMicrophoneNote = isMicrophonePermissionDenied && this.isMicrophoneVisible;
		const hasMicrophoneAndCameraNote = hasMicrophoneNote;

		if (hasMicrophoneAndCameraNote) {
			return 'dashboard.quickSettings.note.microphoneAndcameraPrivacyNotes';
		} else if (hasMicrophoneNote) {
			return 'dashboard.quickSettings.note.microphoneNote';
		}

		return '';
	}

	private isMicrophonePermissionDenied(): boolean {
		return this.microphoneStatus.available && !this.microphoneStatus.permission;
	}
}
